import styled, { css } from 'styled-components';
import fonts from '@utils/fonts';

import colors from '@utils/colors';
import { mq } from '@utils/responsive';
import { H_PADDING_MOBILE } from '@utils/space';
import { Body, Heading as UnstyledHeading } from '@components/type';

export const Content = styled.div`
  position: relative;
  z-index: 1;
  width: 100%;
  ${mq.gtsm`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    padding-right: ${ H_PADDING_MOBILE };
  `}
`;

export const Tags = styled(Body)`
  margin-bottom: 32px;
  white-space: pre-line;
  text-align: center;
  display: block;
  width: 100% ;
  color: ${(props) => props.outline && props.outline !== 'none' ?
  getThemeStyles(props.colorTheme).background :
  getThemeStyles(props.colorTheme).text};
`;

export const Tag = styled.span`
  display: inline-block;
  padding: 5px 0 5px 10px;
  font-family: ${props => props.bold ? 'Trade Gothic LT Std Cn' : 'Trade Gothic LT Pro'};
  font-weight: ${props => props.bold ? 'bold' : 'regular'};
  font-size: ${props => props.bold ? '26px' : '18px'};

  ${mq.gtmd`
      padding: 5px 0 0 20px;
  `}

  &:after {
    content: '|';
    font-size: 18px;
    font-family: ${props => fonts(props.theme.locale).SANS};
    margin-left: 10px;
    font-weight: normal;

    ${mq.gtmd`
    margin-left: 20px;
  `}
  }
  &.is-last-in-line:after {
    content: '';
  }
`;

export const Heading = styled(UnstyledHeading)`
  margin-bottom: 24px;
  text-align: center;
  width: 100%;
  text-transform: uppercase;
  color: ${(props) => props.outline && props.outline !== 'none' ?
  getThemeStyles(props.colorTheme).background :
  getThemeStyles(props.colorTheme).text};
  ${mq.gtsm`
    margin-bottom: 32px;
  `}
`;

export const Inner = styled.div`
  position: relative;
  z-index: 1;
  padding: 18px ${H_PADDING_MOBILE};
  ${mq.gtmd`
    display: flex;
    padding: 0 calc((100vw - 1280px) / 2);
  `}
  & > svg {
    position: absolute;
    top: 20%;
    right: -200px;
    left: -100px;
    width: calc(100% + 300px);
    z-index: 0;
    ${mq.gtsm`
      top: ${props => props.flipped ? 'auto' : '0'};
      bottom: ${props => props.flipped ? '0' : 'auto'};
      right: 50%;
      left: 0;
      width: 50%;
    `}
  }
`;

export const Wrapper = styled.div`
  overflow: hidden;
  & > svg {
    z-index: 0;
  }
  & > svg:first-of-type {
    fill: ${(props) =>
  props.outline && props.outline !== 'none' ? 'none' : getThemeStyles(props.colorTheme).background};
    stroke: ${(props) =>
  props.outline === 'top' || props.outline === 'both'
    ? getThemeStyles(props.colorTheme).outline
    : 'none'};
    stroke-width: ${(props) =>
  props.outline === 'top' || props.outline === 'both' ? '3px' : 0};
    vertical-align: bottom;
    ${mq.gtsm`
      stroke-width: 1px;
    `}
    ${(props) =>
  props.outline && props.outline !== 'none' &&
  css`
        width: calc(100% + 6px);
        margin-right: -3px;
        margin-bottom: -3px;
        margin-left: -3px;
      `}
  }
  & > svg:last-of-type {
    fill: ${(props) =>
  props.outline && props.outline !== 'none' ? 'none' : getThemeStyles(props.colorTheme).background};
    stroke: ${(props) =>
  props.outline === 'bottom' || props.outline === 'both'
    ? getThemeStyles(props.colorTheme).outline
    : 'none'};
    stroke-width: ${(props) =>
  props.outline === 'bottom' || props.outline === 'both' ? '3px' : 0};
    transform: scale(-1, -1) translateY(1px);
    vertical-align: top;
    ${mq.gtsm`
      stroke-width: 1px;
    `}
    ${(props) =>
  props.outline &&
  css`
        width: calc(100% + 6px);
        margin-right: -3px;
        margin-top: -1px;
        margin-left: -3px;
      `}
  }
`;

export function getThemeStyles(theme) {
  switch (theme) {
    case 'white':
      return {
        outline: colors.B500,
        background: '#fff',
        swirl: colors.B100,
        fill: colors.B200,
        text: colors.B500,
      };
    case 'dark-blue':
      return {
        outline: colors.B500,
        background: colors.B500,
        fill: colors.B200,
        text: colors.B500,

      };
    case 'dark-purple':
      return {
        outline: colors.P500,
        background: colors.P500,
        fill: colors.P200,
        text: colors.P500,
      };
    case 'green':
      return {
        outline: colors.G100,
        background: colors.G100,
        fill: colors.G200,
        text: colors.G500,
      };
    case 'orange':
      return {
        outline: colors.O100,
        background: colors.O100,
        fill: colors.O200,
        text: colors.O500,
      };
    default:
      return {
        outline: colors.Y100,
        background: colors.Y100,
        fill: colors.Y200,
        text: colors.B500,
      };
  }
}
